/**
 * 功能: 绘制slide图片显示
 */
<template lang="pug">
  canvas(:id="'a'+slide._id" :width="canvasWidth" :height="canvasHeight" @mousemove="canvasMove")
</template>

<script>
import apiImg from '@/apis/commuCore'
export default {
  props: {
    slide: { type: Object }
  },
  data () {
    return {
      canvasWidth: 1200,
      canvasHeight: 838,
      fullscreenShow: true,
      fullwebpageShow: true,
      widerShow: false,
      widerData: { canvasWidth: 1200, canvasHeight: window.innerHeight * window.devicePixelRatio },
      fullwebpageData: { canvasWidth: window.innerWidth * window.devicePixelRatio, canvasHeight: window.innerHeight * window.devicePixelRatio },
      fullscreenData: { canvasWidth: window.screen.width * window.devicePixelRatio, canvasHeight: window.screen.height * window.devicePixelRatio }
    }
  },
  methods: {
    // 判断当前屏幕的显示状态绘制图片
    drawImage (type) {
      if (type) {
        if (type === 'widerShow') {
          this.fullwebpageShow = true
          this.widerShow = false
          this.fullscreenShow = true
        } else if (type === 'fullscreenShow') {
          this.fullwebpageShow = true
          this.widerShow = true
          this.fullscreenShow = false
        } else {
          this.fullwebpageShow = false
          this.widerShow = true
          this.fullscreenShow = true
        }
      }
      const url = this.slide.hiImageUrl
      const id = this.slide._id
      const that = this
      const mycanvas = document.getElementById('a' + id)
      const ctx = mycanvas.getContext('2d')
      ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
      const { canvasWidth, canvasHeight } = this.getSize()
      const img = new Image()
      apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + url).then(res => {
        img.src = window.URL.createObjectURL(res)
      })
      img.onload = function () {
        that.isLoading = false
        let ratio = parseInt(img.width) / parseInt(canvasWidth)
        let height = img.height / ratio
        let width = canvasWidth
        if (canvasHeight && (canvasWidth / canvasHeight > img.width / img.height)) {
          ratio = img.height / canvasHeight
          width = img.width / ratio
          height = canvasHeight
        }
        // let canvaswidth = document.getElementsByClassName('swiper-wrapper')[0]
        // canvaswidth.style.width = width + 'px'
        // let swiperSlide = document.getElementsByClassName('swiper-slide-active')[0]
        // swiperSlide.style.width = width + 'px'
        // document.getElementById('a' + id).parentNode.style.width = width + 'px'
        // document.getElementById('a' + id).parentNode.style.height = height + 'px'
        mycanvas.style.backgroundImage = 'url(' + img.src + ')'
        mycanvas.style.backgroundSize = `${width}px ${height}px`
        mycanvas.style.backgroundRepeat = 'no-repeat'
        mycanvas.height = height
        that.canvasHeight = height
        that.canvasWidth = width
        that.$emit('changecanvasWidth', width, height, id)
      }
    },
    // 移动canvas后, 判断选区是否有附件内容, 如果有则绘制选区和按钮, 阴影显示
    canvasMove () {
      let nowEle
      const canvas = document.getElementById('a' + this.slide._id)
      const ctx = canvas.getContext('2d')
      canvas.style.cursor = 'default'
      canvas.onmousemove = (e) => {
        e.preventDefault()
        const x = e.offsetX
        const y = e.offsetY
        const elements = this.slide.elements
        for (const i of elements) {
          const hot = this.isHot(x, y, i)
          if (hot) {
            if (nowEle !== i) {
              ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
              const width = hot.eleWidth
              const left = hot.eleLeft
              const top = hot.eleTop
              const height = hot.eleHeight
              if (i.attachment.internalMemo) {
                this.drawButton(ctx, width, height, left, top, 'Memo')
              }
              if (i.attachment._class === -1) {
                this.drawButton(ctx, width, height, left, top, '', '文本')
              } else if (i.attachment._class === 0) {
                this.drawButton(ctx, width, height, left, top, '', '图说')
              } else if (i.attachment._class === 1) {
                this.drawButton(ctx, width, height, left, top, '', '表说')
              } else if (i.attachment._class === 2) {
                this.drawButton(ctx, width, height, left, top, '', '数说')
              } else if (i.attachment._class === 3) {
                this.drawButton(ctx, width, height, left, top, '', '专家说', 64)
              } else {
                this.drawButton(ctx, width, height, left, top, '', '数说')
              }
              nowEle = i
              canvas.style.cursor = 'pointer'
            }
            break
          } else {
            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
            nowEle = 'undefined'
            canvas.style.cursor = 'default'
          }
        }
      }
      canvas.onclick = (e) => {
        const x = e.offsetX
        const y = e.offsetY
        const elements = this.slide.elements
        for (const i of elements) {
          const hot = this.isHot(x, y, i)
          if (hot) {
            var type = this.isButton(x, y, i)
            if (type && type === 1) {
              if ((i.attachment._id || i._id) && i.attachment.internalMemo) {
                const relativeId = i.attachment._id || i._id
                // this.$refs.memoDialog.show()
                this.$emit('showMemo', relativeId)
              }
            } else {
              if (i.attachment._class !== -1 && i.attachment._class !== 3) {
                this.$emit('showAttachment', i)
              }
            }
          }
        }
      }
    },
    // 判断当前选区位置是否有附件内容
    isHot (x, y, ele) {
      const width = this.canvasWidth
      const height = this.canvasHeight
      const eleWidth = Math.abs(ele.width) * width
      const eleHeight = Math.abs(ele.height) * height
      let eleTop = ele.top * height
      if (ele.height < 0) {
        eleTop = (ele.top - Math.abs(ele.height)) * height
      }
      let eleLeft = ele.left * width
      if (ele.width < 0) {
        eleLeft = (ele.left - Math.abs(ele.width)) * width
      }
      if (x > eleLeft && x < eleLeft + eleWidth && y > eleTop && y < eleTop + eleHeight) {
        return { eleWidth, eleHeight, eleTop, eleLeft }
      } else {
        return false
      }
    },
    // 绘制按钮
    drawButton (ctx, width, height, left, top, text, type, deviation = 54) {
      ctx.beginPath()
      ctx.fillStyle = '#2d2d2d'
      ctx.globalAlpha = 0.1
      ctx.rect(left, top, width, height)
      ctx.fill()
      ctx.closePath()

      ctx.beginPath()
      ctx.strokeStyle = '#2d2d2d'
      ctx.fillStyle = '#2d2d2d'
      ctx.globalAlpha = 0.7
      ctx.moveTo(left + width - 147, top)
      ctx.lineTo(left + width - 147, top + 15)
      ctx.arc(left + width - 137, top + 15, 10, Math.PI, Math.PI / 2, true)
      ctx.lineTo(left + width - 77, top + 25)
      ctx.lineTo(left + width - 77, top)
      ctx.lineTo(left + width - 147, top)
      ctx.closePath()
      if (type) {
        ctx.beginPath()
        ctx.fillStyle = '#2d2d2d'
        ctx.rect(left + width - 70, top, 70, 25)
        ctx.fill()
        ctx.font = '1.2rem solid PingFangSC-Regular'
        ctx.fillStyle = 'white'
        ctx.fillText(type, left + width - deviation, top + 18)
        ctx.stroke()
        ctx.closePath()
      }
      if (text) {
        ctx.beginPath()
        ctx.strokeStyle = '#2d2d2d'
        ctx.fillStyle = '#2d2d2d'
        ctx.globalAlpha = 0.7
        ctx.moveTo(left + width - 147, top)
        ctx.lineTo(left + width - 147, top + 15)
        ctx.arc(left + width - 137, top + 15, 10, Math.PI, Math.PI / 2, true)
        ctx.lineTo(left + width - 77, top + 25)
        ctx.lineTo(left + width - 77, top)
        ctx.lineTo(left + width - 147, top)
        ctx.fill()
        ctx.font = '1.2rem solid PingFangSC-Regular'
        ctx.fillStyle = 'white'
        ctx.fillText(text, left + width - 142, top + 18)
        ctx.stroke()
        // canvas.style.cursor = 'pointer'
        ctx.closePath()
      }
    },
    // 判断当前显示的状态, 正常显示、网页全屏、屏幕全屏
    getSize () {
      if (!this.widerShow) {
        return this.widerData
      } else if (!this.fullwebpageShow) {
        return this.fullwebpageData
      } else if (!this.fullscreenShow) {
        return this.fullscreenData
      }
    },
    // 判断当前选区是什么类型的按钮
    isButton (x, y, ele) {
      const width = this.canvasWidth
      const height = this.canvasHeight
      const eleWidth = Math.abs(ele.width) * width
      let eleTop = ele.top * height
      if (ele.height < 0) {
        eleTop = (ele.top - Math.abs(ele.height)) * height
      }
      let eleLeft = ele.left * width
      if (ele.width < 0) {
        eleLeft = (ele.left - Math.abs(ele.width)) * width
      }
      if (x > eleLeft + eleWidth - 147 && x < eleLeft + eleWidth - 77 && y > eleTop && y < eleTop + 25) {
        return 1
      } else if (x > eleLeft + eleWidth - 70 && x < eleLeft + eleWidth && y > eleTop && y < eleTop + 25) {
        return 2
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.drawImage()
  }
}
</script>
